var _circle, _path, _path2, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnc1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.6426,
    cy: 76.6418,
    r: 34.9921,
    transform: "rotate(-0.395643 76.6426 76.6418)",
    fill: "#EBD0A1",
    stroke: "#C8B07A",
    strokeWidth: 6.77267
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.303 60.7531C87.1667 60.218 86.6223 59.8946 86.0871 60.0309L77.3657 62.2526C76.8305 62.389 76.5071 62.9333 76.6435 63.4685C76.7798 64.0037 77.3242 64.3271 77.8594 64.1907L85.6118 62.2159L87.5866 69.9683C87.723 70.5035 88.2673 70.8269 88.8025 70.6905C89.3377 70.5542 89.6611 70.0098 89.5247 69.4746L87.303 60.7531ZM78.8598 75.5419L87.1938 61.5107L85.4742 60.4893L77.1402 74.5206L78.8598 75.5419Z",
    fill: "#96896B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.01 89.8586C58.9319 90.4053 59.3118 90.9118 59.8586 90.9899L68.7681 92.2627C69.3149 92.3408 69.8214 91.9609 69.8995 91.4142C69.9776 90.8675 69.5977 90.3609 69.051 90.2828L61.1314 89.1515L62.2627 81.2319C62.3408 80.6851 61.9609 80.1786 61.4142 80.1005C60.8675 80.0224 60.3609 80.4023 60.2828 80.949L59.01 89.8586ZM75.4 77.2L59.4 89.2L60.6 90.8L76.6 78.8L75.4 77.2Z",
    fill: "#96896B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.6443,
    cy: 76.6405,
    r: 2.82226,
    transform: "rotate(-0.395643 76.6443 76.6405)",
    fill: "#96896B",
    stroke: "#96896B",
    strokeWidth: 1.12878
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 46,
    width: 3,
    height: 6,
    fill: "#FFE0C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2422,
    y: 57,
    width: 3,
    height: 6,
    transform: "rotate(45 97.2422 57)",
    fill: "#FFE0C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2422,
    y: 93,
    width: 3,
    height: 6,
    transform: "rotate(45 62.2422 93)",
    fill: "#FFE0C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 94.0938,
    width: 3,
    height: 6,
    transform: "rotate(-44.2411 93 94.0938)",
    fill: "#FFE0C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 57.0938,
    width: 3,
    height: 6,
    transform: "rotate(-44.2411 55 57.0938)",
    fill: "#FFE0C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 100,
    width: 3,
    height: 6,
    fill: "#FFE0C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 74,
    width: 3,
    height: 6,
    transform: "rotate(90 54 74)",
    fill: "#FFE0C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 74,
    width: 3,
    height: 6,
    transform: "rotate(90 107 74)",
    fill: "#FFE0C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnc1);
export default __webpack_public_path__ + "static/media/unc-1.e7fae9df48992dfd2dc6f8e36205b82d.svg";
export { ForwardRef as ReactComponent };